var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumesHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic volumes",
    clipPath: "url(#clip0_9146_76099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic volumes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1875 19H5.8125C4.25906 19 3 17.7913 3 16.3V3.7C3 2.2087 4.25906 1 5.8125 1H15.1875C16.7409 1 18 2.2087 18 3.7V16.3C18 17.7913 16.7409 19 15.1875 19Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1875 19H5.8125C4.25906 19 3 17.8808 3 16.5C3 15.1192 4.25906 14 5.8125 14H15.1875C16.7409 14 18 15.1192 18 16.5C18 17.8808 16.7409 19 15.1875 19ZM15.1875 15.6667C14.6719 15.6667 14.25 16.0417 14.25 16.5C14.25 16.9583 14.6719 17.3333 15.1875 17.3333C15.7031 17.3333 16.125 16.9583 16.125 16.5C16.125 16.0417 15.7031 15.6667 15.1875 15.6667Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 7.5C15 9.984 12.984 12 10.5 12C9.582 12 8.727 11.721 8.016 11.262L10.239 9.039C10.59 8.688 10.59 8.112 10.239 7.761C9.888 7.41 9.312 7.41 8.961 7.761L6.738 9.984C6.279 9.273 6 8.418 6 7.5C6 5.016 8.016 3 10.5 3C12.984 3 15 5.016 15 7.5Z",
    fill: "#2894FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumesHover);
export default __webpack_public_path__ + "static/media/volumes-hover.d3904375a5943c903c935ea9cf33f8b9.svg";
export { ForwardRef as ReactComponent };